import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { DocumentCategory } from '../models/declarations';
import { DocumentViewRequest } from '../models/documentViewRequest';
import { MailRequest, MailRequestEx } from '../models/mailRequest';
import { PropertyDocumentModel } from '../models/PropertyDocumentModel';
import { DocumentType } from '../models/whatsappRequest';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-propertydocumentscat',
  templateUrl: './propertydocumentscat.component.html',
  styleUrls: ['./propertydocumentscat.component.scss']
})
export class PropertydocumentscatComponent implements OnInit {

  constructor(private router: Router, private data:DataService,private datePipe: DatePipe) { }
  public docs : Array<PropertyDocumentModel>;
  private original_docs :Array<PropertyDocumentModel>;
  public cat : DocumentCategory;

  public searchtext:string;


  ngOnInit(): void {
    this.cat = this.data.SelectedDocumentCategory;
    this.docs = this.data.SelectedProperty.propertydocuments.filter(v => v.category == this.cat.DocumentCategoryCode);
    this.original_docs = this.docs;
  }

  
  onViewDocument(documentid : PropertyDocumentModel){
    var req = new DocumentViewRequest();
    req.Document = documentid;
    req.DocType = DocumentType.msgtype_propertydocument;
    this.data.ActiveDocumentViewRequest = req;
    this.router.navigate(['documentviewer'],{skipLocationChange: false});
  }

  onViewPropertyDocumentDetails(doc: PropertyDocumentModel){
    this.data.SelectedPropertyDocument = doc;
    this.router.navigate(['propertydocumentdetails'],{skipLocationChange: false});
  }


  onEmail() : boolean {
    var req: MailRequestEx = new MailRequestEx();
    this.docs.forEach(element => {

      req.MailResources.push({
        Title : element.title,
        URL : element.storagekey,
        ResourceType : "doc"
      });
    });  
    this.data.MailReqEx = req;
    this.router.navigate(['mailprogress']);
    return false;
  }

  onWhatsapp() : void {

  }

  onSearchTextChanged() {
    console.log(this.searchtext);
    /*
    this.docs = this.original_docs.filter( x => {
      return RegExp('.*' + this.searchtext + '.*',"i").test(this.datePipe.transform(x.documentdate * 1000,"dd/MM/yyyy").toString() + " " + x.title + " " + x.cat.DocumentCategoryName);
    });
    console.log(this.docs.length);
    */
    this.data.search_request<Array<string>>(
      {
        searchText: this.searchtext,
        p1: '',
        p2: '',
        p3: '',
        p4: ''
      }, 'POST'
    ).subscribe((v) => {
      this.docs = this.original_docs.filter(
        (e) => {
          return v.find((x) => x === e.id);
        },
      );
    });
  }
}
